"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$ = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$outboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$inboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$ = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$outboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$inboundSchema = void 0;
exports.getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurityToJSON = getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurityToJSON;
exports.getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurityFromJSON = getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurityFromJSON;
exports.getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequestToJSON = getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequestToJSON;
exports.getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequestFromJSON = getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$;
(function (GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$) {
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$inboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$.inboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$inboundSchema;
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$outboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$.outboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$outboundSchema;
})(GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$ || (exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$ = GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$ = {}));
function getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurityToJSON(getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity) {
    return JSON.stringify(exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$outboundSchema
        .parse(getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity));
}
function getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetSecurity' from JSON`);
}
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$;
(function (GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$) {
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$inboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$.inboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$inboundSchema;
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$outboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$.outboundSchema = exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$outboundSchema;
})(GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$ || (exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$ = GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$ = {}));
function getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequestToJSON(getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest) {
    return JSON.stringify(exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$outboundSchema
        .parse(getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest));
}
function getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGetRequest' from JSON`);
}
//# sourceMappingURL=getnationalaveragetimeonmarketstatslettingsnationalaveragetimeonmarketget.js.map